import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

// Draggable before/after image comparison slider.
export const BeforeAfterSlider = ({ before, after, beforeLabel = "Before", afterLabel = "After", testid = "before-after" }) => {
  const [pos, setPos] = useState(52);

  return (
    <div
      data-testid={testid}
      className="relative aspect-square w-full select-none overflow-hidden rounded-3xl border border-navy/10 bg-white"
    >
      {/* AFTER (base layer) */}
      <img src={after} alt={afterLabel} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      <span className="pointer-events-none absolute right-3 top-3 rounded-full bg-navy/70 px-3 py-1 text-xs font-semibold text-white backdrop-blur-md">{afterLabel}</span>

      {/* BEFORE (clipped to left of handle) */}
      <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={beforeLabel} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
        <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-white/80 px-3 py-1 text-xs font-semibold text-navy backdrop-blur-md">{beforeLabel}</span>
      </div>

      {/* Divider + handle */}
      <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -ml-px w-0.5 bg-white shadow-[0_0_8px_rgba(0,0,0,0.4)]" />
        <div className="absolute top-1/2 -ml-5 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-full border border-navy/10 bg-white text-navy shadow-lg">
          <MoveHorizontal className="h-4 w-4" />
        </div>
      </div>

      {/* Drag / keyboard control (transparent, covers the image) */}
      <input
        type="range"
        min={0}
        max={100}
        value={Math.round(pos)}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label={`Reveal ${afterLabel} over ${beforeLabel}`}
        data-testid={`${testid}-range`}
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
};
